<template>
  <div style="height: 100%">
    <v-slide-x-transition leave-absolute hide-on-leave>
      <div
        style="height: 100%; max-width: 500px"
        :key="view"
        class="transition mx-auto"
      >
        <div v-if="loading" class="text-center">
          <div class="text-center mt-2">
            <img width="62px" src="@/assets/logo.png" />
          </div>
          <v-progress-circular
            indeterminate
            class="mt-6"
            color="primary"
            size="65"
          ></v-progress-circular>
        </div>
        <component class="Kanit" v-else :is="view"></component>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import queryString from "query-string";
import Register from "./Register/main";
import Login from "./Login.vue";
// import Rewardhistory from "./Rewardhistory.vue";
import Rewardhistory from "./RewardHistory/main.vue";
import Pointhistory from "./Pointhistory.vue";
import ForgetPassword from "./ForgetPassword/main.vue";
import ChangePhoneNo from "./ChangePhoneNo/main.vue";
import LoginSuccess from "./LoginSuccess.vue";
import PointManager from "./PointManager/main.vue";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions.vue";
import CollectEdit from "./PointManager/CollectEdit.vue";
import OrderStatusLog from "./RewardHistory/OrderStatusLog.vue";

import axios from "axios";
export default {
  components: {
    Register,
    Login,
    ForgetPassword,
    LoginSuccess,
    PointManager,
    Pointhistory,
    Rewardhistory,
    ChangePhoneNo,
    TermsAndConditions,
    CollectEdit,
    OrderStatusLog,
  },
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    var vm = this;
    vm.queryinit();
    await vm.init();
    await vm.checkLogin();

    this.loading = false;
    vm.getBranch();
  },
  methods: {
    getBranch() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "toacrm/branchs", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.branch = response.data.data;
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    getMember() {
      return new Promise((resolve) => {
        var data = { userid: this.userid, pageid: this.query.pageid };
        axios
          .get(this.serverUrl + "toacrm/member", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.member = response.data.data[0];
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    init() {
      var vm = this;
      return new Promise(async (resolve) => {
        // var liffid = "1656164118-pexDLjAY"; // production
        // var liffid = "1656113611-ob2dLAVM"; //localhost
        // var liffid = "1656113611-wqB9RbW6" //toacrmtest.zwiz.ai
        const liffid = process.env.VUE_APP_LIFF_ID;

        if (this.query.apptype == "line") {
          await this.initializeLiff(liffid);
          this.$store.state.userid =
            this.$store.state.profile.userId + "__" + this.query.pageid;
          // this.$store.state.userid =
          //   "U3bec107c9b1f046d0f8fe6d3b60f932c__108537541446937";
          resolve();
        } else {
          this.$store.state.userid = this.query.userid;
          window.extAsyncInit = function() {
            // the Messenger Extensions JS SDK is done loading
          };
          resolve();
        }
      });
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    async checkLogin() {
      return new Promise((resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
        };

        axios
          .get(this.serverUrl + "toacrm/check-login", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.member = response.data.data[0];
              this.$store.state.redirectview = this.query.view;
              this.query.view = "TermsAndConditions";
              // await this.getMember();

              //   if (["Login", "Register"].includes(this.query.view)) {
              //     this.query.tab = "profile";
              //     this.query.view = "PointManager";
              //   }
            } else if (response.data.responsecode == 204) {
              this.$store.state.redirectview = "Register";
              this.query.view = "TermsAndConditions";
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
};
</script>

<style>
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
